import { render } from "./Refills.vue?vue&type=template&id=536678de"
import script from "./Refills.vue?vue&type=script&lang=js"
export * from "./Refills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__